import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { YourAPPProductType } from "./app/core/shared/contentTypes";

// jQuery for the usage of on() and getScript() functions
import * as $ from "jquery";

// hammerjs for touch gestures (is needed for Material elements and Swipe navigation)
import "hammerjs";

// Lightweight ES6 Promise polyfill for the browser and node. https://www.npmjs.com/package/promise-polyfill
import "promise-polyfill/src/polyfill";

// smoothscroll.polyfill for smooth scrolling in iOS
import * as smoothscroll from "smoothscroll-polyfill";

changeBasePath();
skipNotificationsUntilCordovaIsReady();
smoothscroll.polyfill();
toggleSystem();
embedCheckoutComponents();
bootstrapApplication();
initializeCordova();
enableDebugging();
installPushServiceWorkerForWebshop();

function changeBasePath() {
  if (environment.producttype !== YourAPPProductType.app_android && environment.producttype !== YourAPPProductType.app_ios && !usesFileProtocol()) {
    const base = document.getElementsByTagName("base")[0];
    base.setAttribute(
      "href",
      isInDevelopment() ? getBaseForDevServer() : getBaseForProductionServer()
    );
  }
}

function isInDevelopment() {
  return document.location.port === "8000";
}

function getBaseForDevServer() {
  return "/";
}

function getBaseForProductionServer() {
  return "/" + window.location.pathname.split("/")[1] + "/";
}

function usesFileProtocol() {
  return checkProtocol("file");
}

function checkProtocol(protocol: string): boolean {
  return document.location.protocol.toLowerCase() === (protocol + ":")
}

/**
 *  Is needed to call fireQueudEvents() from cordova-plugin-local-notifications.
 *  In addition this is needed to read push messages from closed state.
 */
function skipNotificationsUntilCordovaIsReady() {
  (<any>window).skipLocalNotificationReady = true;
}

function toggleSystem() {
  if (environment.production) {
    enableProdMode();
  }
}

function embedCheckoutComponents() {
  // TODO: check comEnvironment if browser (and not android or ios)
  if (environment.checkout && environment.checkout.adyen) {
    let adyen = environment.checkout.adyen;

    const $link = $("<link>")
      .attr("rel", "stylesheet")
      .attr("href", adyen.style.href)
      .attr("integrity", adyen.style.integrity)
      .attr("crossorigin", adyen.style.crossorigin);

    const $script = $("<script />")
      .attr("defer", "") // läd script nach der darstellung der html
      .attr("src", adyen.script.src)
      .attr("integrity", adyen.script.integrity)
      .attr("crossorigin", adyen.script.crossorigin);

    // check is ios and dont use google pay (oder ist es auch im ios möglich?)
    const $google_script = $("<script />")
      .attr("defer", "") // läd script nach der darstellung der html
      .attr("src", adyen.google_script.src)
      .attr("integrity", adyen.style.integrity)
      .attr("crossorigin", adyen.style.crossorigin);

    $("head").append($link);
    $("body").append(
      /*$google_script googlepay momentan wegen der coockies auskommentiert,*/ $script
    );
  }
}

function bootstrapApplication() {
  window["bootstrapUAPP"] = () => {
    platformBrowserDynamic().bootstrapModule(AppModule);
  };

  // Deviceready is fired from Cordova, when it is fully initialized. After completeness we have to bootstrap the AppModule.
  $(document).on("deviceready", window["bootstrapUAPP"]);
}

function initializeCordova() {
  $.getScript("cordova.js");
}

function enableDebugging() {
  if (environment.debug.remoteDebugging) {
    $.getScript(environment.debug.remoteDebuggingUrl + "/vorlon.js");
  }
}

function installPushServiceWorkerForWebshop() {
  // Browser mit Service-Worker
  if (YourAPPProductType.webshop === environment.producttype) {
    window.addEventListener("load", () => {
      if ("serviceWorker" in navigator) {
        // TODO: "PushManager" does not work in window on the iPhone.
        navigator.serviceWorker
          .register("./app-sw.js")
          .then((serviceWorkerRegistration) => {
            console.info("Service worker was registered.");
          })
          .catch((error) => {
            console.error(
              "An error occurred while registering the service worker.",
              error
            );
          });
      } else {
        console.error(
          "Browser does not support service workers or push messages."
        );
      }
    });
  }
}
